import { CirclePartnerHealthResource } from '@calm/evexia-web-sdk';
import ResourceCard from '@rhg/components/resources/resource-card';
import { Box } from '@rhg/libs/material';
import { formatDataForActionSheet } from '@rhg/utils/resources';
import { RESOURCES_VIEW_ALL_THRESHOLD } from '../heading';

interface ResourcesCarouselListProps {
    resources: CirclePartnerHealthResource[];
    setActionDialogData: (data: any) => void;
    partnerDisplayName?: string;
}

function ResourcesCarouselList({
    resources,
    setActionDialogData,
    partnerDisplayName,
}: ResourcesCarouselListProps) {
    const displayedResources = resources.slice(0, RESOURCES_VIEW_ALL_THRESHOLD);

    return (
        <Box data-testid="resources-carousel-list">
            {displayedResources.map((resource, index) => {
                return (
                    <ResourceCard
                        key={index}
                        resource={resource}
                        onClick={() =>
                            setActionDialogData(
                                formatDataForActionSheet(
                                    resource,
                                    'CarePlan',
                                    partnerDisplayName
                                )
                            )
                        }
                    />
                );
            })}
        </Box>
    );
}

export default ResourcesCarouselList;
